import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { QuestionnaireService } from './questionnaire.service';
var QuestionnairePanelComponent = /** @class */ (function () {
    function QuestionnairePanelComponent(logger, service, cdRef) {
        this.logger = logger;
        this.service = service;
        this.cdRef = cdRef;
        this.changePanel = new EventEmitter();
        this.msg = {};
        this.readonly = false;
        this.pQuestion = [];
        this.pParts = [];
        this.pCopy = [];
        this.initPanelVal = '0';
        this.panelVal = {};
    }
    QuestionnairePanelComponent.prototype.ngOnInit = function () {
        var question = jsonpath.value(this.pQuestion, '$..[?(@.code=="' + this.val + '")]');
        var parts = jsonpath.value(this.pParts, '$..[?(@.code=="' + this.val + '")]');
        this.panelVal = {};
        this.panelVal["question" /* question */ + '-' + this.seq] = question ? this.val : this.initPanelVal;
        this.panelVal["parts" /* parts */ + '-' + this.seq] = parts ? this.val : this.initPanelVal;
        this.panelVal["copy" /* copy */ + '-' + this.seq] = this.initPanelVal;
    };
    QuestionnairePanelComponent.prototype.ngOnChanges = function (changes) {
        if (changes.val && !changes.val.firstChange) {
            this.ngOnInit();
        }
    };
    QuestionnairePanelComponent.prototype.onChange = function (e, type) {
        if (this.seq !== 0 || e.val !== this.initPanelVal) {
            if (type === "copy" /* copy */ && this.items[parseInt(e.val) - 1].form_type === this.val) {
                this.panelVal[type + '-' + this.seq] = e.val;
                this.cdRef.detectChanges();
                this.panelVal[type + '-' + this.seq] = this.initPanelVal;
            }
            else {
                for (var _i = 0, _a = Object.keys(this.panelVal); _i < _a.length; _i++) {
                    var key = _a[_i];
                    if (key === type + '-' + this.seq) {
                        this.panelVal[key] = e.val;
                    }
                    else {
                        this.panelVal[key] = this.initPanelVal;
                    }
                }
            }
            this.cdRef.detectChanges();
            if (e.val === this.initPanelVal) {
                this.changePanel.emit({ panel_type: null, val: null });
            }
            else {
                this.changePanel.emit({ panel_type: type, val: e.val });
            }
        }
    };
    QuestionnairePanelComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'questionnaire-panel',
                    template: "<dl class=\"form\">\n  <dt class=\"form_dt form_dt-inline\"></dt>\n  <dd class=\"form_dd\">\n    <ul>\n      <li class=\"form_li\">\n        <columngroup *ngIf=\"pQuestion.length > 0\" [key]=\"'forminline'\" [col]=\"{\n                                        key: 'question-' + seq,\n                                        controlType: 'select',\n                                        required: true,\n                                        readonly: readonly,\n                                        params: { options: pQuestion }\n                                    }\" [val]=\"panelVal\" [msg]=\"msg\" (changeVal)=\"onChange($event, 'question')\"></columngroup>\n      </li>\n      <li class=\"form_li\">\n        <columngroup *ngIf=\"pParts.length > 0\" [key]=\"'forminline'\" [col]=\"{\n                                        key: 'parts-' + seq,\n                                        controlType: 'select',\n                                        required: true,\n                                        readonly: readonly,\n                                        params: { options: pParts }\n                                    }\" [val]=\"panelVal\" [msg]=\"msg\" (changeVal)=\"onChange($event, 'parts')\"></columngroup>\n      </li>\n      <li class=\"form_li\">\n        <columngroup *ngIf=\"pCopy.length > 0\" [key]=\"'forminline'\" [col]=\"{\n                                        key: 'copy-' + seq,\n                                        controlType: 'select',\n                                        required: true,\n                                        readonly: readonly,\n                                        params: { options: pCopy }\n                                    }\" [val]=\"panelVal\" [msg]=\"msg\" (changeVal)=\"onChange($event, 'copy')\"></columngroup>\n      </li>\n    </ul>\n  </dd>\n</dl>\n"
                }] }
    ];
    /** @nocollapse */
    QuestionnairePanelComponent.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: QuestionnaireService },
        { type: ChangeDetectorRef }
    ]; };
    QuestionnairePanelComponent.propDecorators = {
        changePanel: [{ type: Output }],
        items: [{ type: Input }],
        seq: [{ type: Input }],
        val: [{ type: Input }],
        msg: [{ type: Input }],
        readonly: [{ type: Input }],
        pQuestion: [{ type: Input }],
        pParts: [{ type: Input }],
        pCopy: [{ type: Input }]
    };
    return QuestionnairePanelComponent;
}());
export { QuestionnairePanelComponent };
//# sourceMappingURL=questionnaire-panel.component.js.map